import {Master} from '../master/master.model';
export class RefusedMaster {
    constructor(
        public id?: number,
        public refusalDocumentUserBlobId?: number,
        public refusalDocumentUserBlobFilename?: string,
        public master?: Master,
        public masterTitle?: string
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/refused-master/refused-master.model.ts